import { LOCAL_STORAGE_KEYS } from "@/src/config/constant";

const PLAN_GUIDE_ONBOARDING_SCENE = "plan_guide";

/** 与 backend ReferenceType.ONBOARDING_GUIDE 对齐的首条 onboarding 消息 */
export const ONBOARDING_GUIDE_QUESTION =
  "[Meet Ed](referenceType=onboarding_guide)\nonboarding guide";

export type OnboardingGuideEntryScene =
  "default" | typeof PLAN_GUIDE_ONBOARDING_SCENE;

export type ResolveOnboardingGuideChatInitOptions = {
  /** URL `scene`：plan 无草稿时为 plan_guide */
  entryScene?: OnboardingGuideEntryScene;
  /** plan_guide 体检维度 code（101–403），对应 question 与 URL `code` */
  dimensionCode?: string;
};

export type OnboardingGuideChatInit = {
  /** 是否应向 ChatModalContent 传入 chatInfo.question */
  shouldPassChatInfo: boolean;
  chatInfo?: {
    question: string;
    autoRenew: boolean;
  };
};

/**
 * 进入 onboarding chat 时下发首条 question；刷新页面会重新请求。
 *
 * Plan 无草稿（`entryScene=plan_guide` + `dimensionCode`）：下发 plan_guide 首条消息。
 */
export const resolveOnboardingGuideChatInit = (): OnboardingGuideChatInit => {
  return {
    shouldPassChatInfo: true,
    chatInfo: {
      question: ONBOARDING_GUIDE_QUESTION,
      autoRenew: true,
    },
  };
};

export const getStoredOnboardingChatId = (): string | null => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    return localStorage.getItem(LOCAL_STORAGE_KEYS.CHAT_ID);
  } catch {
    return null;
  }
};
